import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import CloseIcon from '@material-ui/icons/Close';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
    color: '#c2c2c',
    fontWeight: '400',
    fontSize: '1rem',
    fontFamily: "'Roboto Mono', monospace",
  },
};


const BaseDialog = ({classes, title, onClose, open, text, fullScreen}) => (
  <Dialog
    fullScreen
    open={open}
    onClose={onClose}
  >
    <AppBar className="DialogBar" position="static" elevation={2}>
      <div className="Content-wrapper ">
        <div className="content">
          <Toolbar disableGutters>
            <Typography variant="title" color="inherit" className={classes.flex}>
              {title}
            </Typography>
            <IconButton onClick={onClose} aria-label="Schließen">
              <CloseIcon style={{ color: 'white' }} />
            </IconButton>
          </Toolbar>
        </div>
      </div>
    </AppBar>
    <div style={{width: '100%', maxWidth: '1200px', textAlign: 'left'}}>

      <div style={{padding: '2rem' }} dangerouslySetInnerHTML={text} />
    </div>
  </Dialog>
);

BaseDialog.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.instanceOf(Object).isRequired,
  fullScreen: PropTypes.bool,
};

BaseDialog.defaultProps = {
  open: false,
  fullScreen: true
};

export default withStyles(styles)(withMobileDialog()(BaseDialog));



// WEBPACK FOOTER //
// ./src/components/layout/BaseDialog.js